<script lang="ts">
	import type { SbImage } from '../types';
	import SbRichtext from '../components/sbRichtext.svelte';
	import GridContainer from '../../../routes/(marketing)/order-now/gridContainer.svelte';
	import Image from '../components/image.svelte';
	import Grid from '../../../routes/(marketing)/order-now/grid.svelte';
	import StarRating from '$lib/review/starRating.svelte';
	import { getYotpoPreview, type YotpoPreview } from '$lib/review/preview';
	import { checkVisibility } from '$lib/actions/checkVisibility';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';

	interface Props {
		content: ISbStoryData<{
			text: ISbRichtext;
			image: SbImage;
		}>['content'];
	}

	let { content }: Props = $props();

	let preview = $state<YotpoPreview>();
</script>

<div
	class="transition-padding"
	style="padding-top: var(--full-header-height)"
	use:checkVisibility={{ threshold: 0 }}
	onvisible={async ({ detail }) => {
		if (!detail || preview) return;

		preview = await getYotpoPreview();
	}}
>
	<GridContainer class="pt-7 lg:pt-12">
		<Grid>
			<div
				class="col-span-full flex flex-col overflow-hidden rounded-2xl bg-stone-5 lg:h-[480px] lg:flex-row lg:items-center"
			>
				<div
					class="flex flex-col items-center text-brown-2 max-lg:px-7 max-lg:pt-9 lg:w-2/5 lg:items-start lg:pl-32"
				>
					<div
						class="text-balance text-center font-serif text-[20px]/[130%] tracking-[-.4px] lg:text-left lg:text-[32px] lg:tracking-[-.64px]"
					>
						<SbRichtext text={content.text} />
					</div>
					<div
						class="mt-4 flex items-center rounded-lg border-[0.5px] border-stone-2 px-4 py-2"
						class:blur-sm={!preview}
					>
						<StarRating score={preview?.averageScore || 4.85} starClass="w-5 h-5" />
						<p class="ml-2 text-[18px]/[140%] font-bold">{preview?.averageScore || 4.85}</p>
						<div class="mx-4 h-[30px] w-[0.5px] bg-stone-2"></div>
						<div class="flex flex-col gap-y-0.5 text-center text-[14px]/[100%]">
							<span class="font-semibold">{preview?.totalReviews || 500}+</span>
							<a class="underline" href="#reviews-widget"> Reviews </a>
						</div>
					</div>
				</div>
				<Image
					src={content.image?.filename}
					alt={content.image?.alt ?? ''}
					title={content.image?.title ?? ''}
					wrapperClass="lg:w-3/5 h-full"
					class="h-full w-full object-cover"
					width={780}
					sizes={{ 1024: { width: 1200 } }}
				/>
			</div>
		</Grid>
	</GridContainer>
</div>
